import api from './index';

const BASE = '/corrected-results';

export const calculateCorrectedResults = async ({ dateFrom, dateTo }: { dateFrom: string; dateTo: string }) => {
    return api.post(`${BASE}/calculate`, { dateFrom, dateTo }).then((res) => res.data);
};

export const getCorrectedResults = async ({
    dateFrom,
    dateTo,
    workingUnitLocation,
}: {
    dateFrom: string;
    dateTo: string;
    workingUnitLocation: number;
}) => {
    return api.get(BASE, { params: { dateFrom, dateTo, workingUnitLocation } }).then((res) => res.data);
};
